function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Controller } from "@hotwired/stimulus";

var src_default = /*#__PURE__*/function (_Controller) {
  _inherits(src_default, _Controller);

  var _super = _createSuper(src_default);

  function src_default() {
    _classCallCheck(this, src_default);

    return _super.apply(this, arguments);
  }

  _createClass(src_default, [{
    key: "initialize",
    value: function initialize() {
      this.intersectionObserverCallback = this.intersectionObserverCallback.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this = this;

      this.class = this.classValue || this.defaultOptions.class || "in";
      this.threshold = this.thresholdValue || this.defaultOptions.threshold || 0.1;
      this.rootMargin = this.rootMarginValue || this.defaultOptions.rootMargin || "0px";
      this.observer = new IntersectionObserver(this.intersectionObserverCallback, this.intersectionObserverOptions);
      this.itemTargets.forEach(function (item) {
        return _this.observer.observe(item);
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this2 = this;

      this.itemTargets.forEach(function (item) {
        return _this2.observer.unobserve(item);
      });
    }
  }, {
    key: "intersectionObserverCallback",
    value: function intersectionObserverCallback(entries, observer) {
      var _this3 = this;

      entries.forEach(function (entry) {
        if (entry.intersectionRatio > _this3.threshold) {
          var target = entry.target;
          target.classList.add(_this3.class);

          if (target.dataset.delay) {
            target.style.transitionDelay = target.dataset.delay;
          }

          observer.unobserve(target);
        }
      });
    }
  }, {
    key: "intersectionObserverOptions",
    get: function get() {
      return {
        threshold: this.threshold,
        rootMargin: this.rootMargin
      };
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {};
    }
  }]);

  return src_default;
}(Controller);

src_default.targets = ["item"];
src_default.values = {
  class: String,
  threshold: Number,
  rootMargin: String
};
export { src_default as default };